import { UserKeys } from "src/constants/userDetails";

export const FEATURE_FLAGS = {
    DIGITAL_MEMBER_CARDS: "digital_member_cards",
    BUSINESS_CHAT: "business_chat",
    JOB_LISTINGS: "job_listings",
    STATISTICS: "statistics",
    QUOTES: "quotes",
    MOOD_TRACKER: "mood_tracker",
    GOAL_TRACKER: "goal_tracker",
    HABIT_TRACKER: "habit_tracker",
    MY_ME_APP: "my_me_app",
    PLAYLISTS: "playlists",
    MY_CONTACTS: "my_contacts",
    SOCIAL_PROCUREMENT: "social_procurement",
    PERKS: "perks",
    DONATIONS: "donations",
    NOTICEBOARD: "noticeboard",
    CHECKED_IN: "checked_in",
    BODY_AND_MIND: "body_mind",
    POLLS: "polls",
    BUSINESS_DIRECTORY: "business_directory",
    TEAM_GOALS: "team_goals",
    CHECKLIST: "checklist",
    EMAIL_CAMPAIGNS: "email_campaigns",
    USER_LISTS: "user_lists",
    ADVERTISING: "advertising",
    SURVEYS: "surveys",
    BILLING: "billing",
};

/**
 * Normalize feature flags from user object
 */
export const getFeatureFlags = (user) => {
    return user?.featureFlags || user?.[UserKeys.FEATURE_FLAGS] || [];
};

/**
 * Generic checker (THIS is what you wanted)
 */
export const hasFeature = (user, featureFlag) => {
    const flags = getFeatureFlags(user);
    return flags.includes(featureFlag);
};
